export default "__VITE_ASSET__7bbec1a2__"